import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

export default function MovieCard({ movie, className = '' }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className={`group block bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer ${className}`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 美国伦理电影`}
          className="w-full h-full object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-semibold">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute top-2.5 right-2.5 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs">
          {movie.year}
        </span>
      </div>
      <div className="p-3.5">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">{movie.originalTitle}</p>
        <div className="mt-2.5 flex items-center gap-1.5 flex-wrap">
          {movie.genres.map((g) => (
            <span key={g} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs">
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}